import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MaintenanceService } from '@app/core/services/maintenance.service';
import { map, catchError, of } from 'rxjs';

export const maintenanceGuard: CanActivateFn = (route, state) => {
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);

  // ✅ Check backdoor first
  if (maintenanceService.checkBackdoorParam()) {
    return true;
  }

  // If already in maintenance mode, redirect immediately
  if (maintenanceService.isMaintenanceMode()) {
    router.navigate(['/maintenance']);
    return false;
  }

  return maintenanceService.checkMaintenanceStatus().pipe(
    map(response => {
      if (response.maintenanceMode && response.timeToMaintenanceInSeconds === 0) {
        // Redirect to maintenance page
        router.navigate(['/maintenance']);
        return false;
      }
      return true;
    }),
    catchError(error => {
      console.error('Error checking maintenance status:', error);
      // On error, allow navigation (fail-safe)
      return of(true);
    })
  );
};